__turbopack_context__.v({
  "breadcrumbs": "ArticleHero-module-scss-module__mhmR0a__breadcrumbs",
  "container": "ArticleHero-module-scss-module__mhmR0a__container",
  "eyebrow": "ArticleHero-module-scss-module__mhmR0a__eyebrow",
  "image": "ArticleHero-module-scss-module__mhmR0a__image",
  "left": "ArticleHero-module-scss-module__mhmR0a__left",
  "link": "ArticleHero-module-scss-module__mhmR0a__link",
  "main": "ArticleHero-module-scss-module__mhmR0a__main",
  "meta": "ArticleHero-module-scss-module__mhmR0a__meta",
  "overlay": "ArticleHero-module-scss-module__mhmR0a__overlay",
  "pattern": "ArticleHero-module-scss-module__mhmR0a__pattern",
  "subhead": "ArticleHero-module-scss-module__mhmR0a__subhead",
  "title": "ArticleHero-module-scss-module__mhmR0a__title",
});
